<section class="asset-editor glass-panel">
  <wn-admin-back-link link="/assets" [label]="'ASSET_EDITOR.BACK' | translate"></wn-admin-back-link>
  <p class="eyebrow">{{ 'ASSET_EDITOR.EYEBROW' | translate }}</p>
  <h1>{{ (assetId() ? 'ASSET_EDITOR.TITLE_EDIT' : 'ASSET_EDITOR.TITLE_CREATE') | translate }}</h1>
  <p class="lede">{{ 'ASSET_EDITOR.LEDE' | translate }}</p>

  @if (loading()) {
    <p class="asset-editor__status" role="status">{{ 'ASSET_EDITOR.LOADING' | translate }}</p>
  }
  @if (loadError(); as err) {
    <p class="asset-editor__error" role="alert">{{ err }}</p>
  }
  @if (apiError(); as err) {
    <p class="asset-editor__error" role="alert">{{ err }}</p>
  }

  @if (!loading()) {
    <form class="asset-editor__form" [formGroup]="form" (ngSubmit)="submit()" novalidate>
      <fieldset class="asset-editor__fieldset">
        <legend>{{ 'ASSET_EDITOR.SECTION_MAIN' | translate }}</legend>

        <label class="field">
          <span class="field__label">{{ 'ASSET_EDITOR.ASSET_CODE' | translate }}</span>
          <input class="field__input" type="text" formControlName="assetCode" autocomplete="off" />
          @if (form.controls.assetCode.invalid && form.controls.assetCode.touched) {
            <span class="field__error">{{ 'ASSET_EDITOR.REQUIRED' | translate }}</span>
          }
        </label>

        @for (lang of langOrder; track lang) {
          @if (lang === 'en') {
            <label class="field">
              <span class="field__label">{{ 'ASSET_EDITOR.TITLE_EN' | translate }}</span>
              <input class="field__input" type="text" formControlName="titleEn" />
              @if (titleErrorKey(form.controls.titleEn); as errorKey) {
                <span class="field__error">{{ errorKey | translate }}</span>
              }
            </label>
          } @else {
            <label class="field">
              <span class="field__label">{{ 'ASSET_EDITOR.TITLE_AR' | translate }}</span>
              <input class="field__input" type="text" formControlName="titleAr" dir="rtl" />
              @if (titleErrorKey(form.controls.titleAr); as errorKey) {
                <span class="field__error">{{ errorKey | translate }}</span>
              }
            </label>
          }
        }

        <label class="field">
          <span class="field__label">{{ 'ASSET_EDITOR.CATEGORY' | translate }}</span>
          <select class="field__input" formControlName="assetCategoryId">
            <option value="">{{ 'ASSET_EDITOR.SELECT_CATEGORY' | translate }}</option>
            @for (category of categories(); track category.id) {
              <option [value]="category.id">{{ categoryTitle(category) }}</option>
            }
          </select>
          @if (form.controls.assetCategoryId.invalid && form.controls.assetCategoryId.touched) {
            <span class="field__error">{{ 'ASSET_EDITOR.REQUIRED' | translate }}</span>
          }
        </label>
      </fieldset>

      <fieldset class="asset-editor__fieldset">
        <legend>{{ 'ASSET_EDITOR.SECTION_DETAILS' | translate }}</legend>

        <label class="field">
          <span class="field__label">{{ 'ASSET_EDITOR.BRANCH' | translate }}</span>
          <select class="field__input" formControlName="currentBranchId">
            <option value="">{{ 'ASSET_EDITOR.NO_BRANCH' | translate }}</option>
            @for (branch of branchOptions(); track branch.id) {
              <option [value]="branch.id">{{ branch.title }}</option>
            }
          </select>
        </label>

        <label class="field">
          <span class="field__label">{{ 'ASSET_EDITOR.SERIAL_NUMBER' | translate }}</span>
          <input class="field__input" type="text" formControlName="serialNumber" autocomplete="off" />
        </label>

        <label class="field">
          <span class="field__label">{{ 'ASSET_EDITOR.PURCHASE_DATE' | translate }}</span>
          <wn-date-picker formControlName="purchaseDate" [ariaLabel]="'ASSET_EDITOR.PURCHASE_DATE' | translate"></wn-date-picker>
        </label>

        <label class="field">
          <span class="field__label">{{ 'ASSET_EDITOR.PURCHASE_COST' | translate }}</span>
          <input class="field__input" type="number" min="0" step="0.01" formControlName="purchaseCost" />
        </label>

        <label class="field">
          <span class="field__label">{{ 'ASSET_EDITOR.WARRANTY_EXPIRY' | translate }}</span>
          <wn-date-picker formControlName="warrantyExpiryDate" [ariaLabel]="'ASSET_EDITOR.WARRANTY_EXPIRY' | translate"></wn-date-picker>
        </label>

        <label class="field field--wide">
          <span class="field__label">{{ 'ASSET_EDITOR.NOTES' | translate }}</span>
          <textarea class="field__input field__input--textarea" rows="3" formControlName="notes"></textarea>
        </label>
      </fieldset>

      <div class="asset-editor__actions">
        <button type="submit" pButton [disabled]="submitting()">
          {{ (assetId() ? 'COMMON.SAVE_CHANGES' : 'COMMON.SAVE') | translate }}
        </button>
        <a routerLink="/assets" class="asset-editor__cancel">{{ 'COMMON.CANCEL' | translate }}</a>
      </div>
    </form>
  }
</section>
